import cityPaymentMethods from "./cityPaymentMethods.component";

const cityPaymentMethodsModule = angular
  .module("app.components.cityPaymentMethods", [])
  .component("cityPaymentMethods", cityPaymentMethods);

export default cityPaymentMethodsModule;



// WEBPACK FOOTER //
// ./src/components/cityPaymentMethods/cityPaymentMethods.module.js